import { useQuery } from "@tanstack/react-query";
import { fetchContactById } from "@/api/contact/contact";
import { useAuth } from "@/providers/auth";

export const useContact = (
  contactId,
  { queryKey, queryFn, enabled, ...config } = {}
) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false && !!contactId;

  let { data, ...rest } = useQuery({
    queryKey: ["contacts", contactId],
    queryFn: async () => await fetchContactById({ userId: id, contactId }),
    staleTime: Infinity,
    enabled: isEnabled,
    ...config,
  });

  if (Array.isArray(data)) {
    data = data[0];
  }

  return { ...rest, data };
};
